import { c } from 'lib/component-utils'
import { ReactNode, SVGProps, useId } from 'react'

export type Icon = (props: SVGProps<SVGSVGElement>) => ReactNode

export const TelegramIcon: Icon = ({ className }) => (
  <svg className={c`${className}`} viewBox="130 130 740 740" preserveAspectRatio="none">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M226.328419,494.722069 C372.088573,431.216685 469.284839,389.350049 517.917216,369.122161 C656.772535,311.36743 685.625481,301.334815 704.431427,301.003532 C708.567621,300.93067 717.815839,301.955743 723.806446,306.816707 C728.864797,310.92121 730.256552,316.46581 730.922551,320.357329 C731.588551,324.248848 732.417879,333.113828 731.758626,340.040666 C724.234007,419.102486 691.675104,610.964674 675.110982,699.515267 C668.10208,736.984342 654.301336,749.547532 640.940618,750.777006 C611.904684,753.448938 589.856115,731.588035 561.733393,713.153237 C517.726886,684.306416 492.866009,666.349181 450.150074,638.200013 C400.78442,605.66878 432.786119,587.789048 460.919462,558.568563 C468.282091,550.921423 596.21508,434.556479 598.691227,424.000355 C599.00091,422.680135 599.288312,417.758981 596.36474,415.160431 C593.441168,412.561881 589.126229,413.450484 586.012448,414.157198 C581.598758,415.158943 511.297793,461.625274 375.109553,553.556189 C355.154858,567.258623 337.080515,573.934908 320.886524,573.585046 C303.033948,573.199351 268.692754,563.490928 243.163606,555.192408 C211.851067,545.013936 186.964484,539.632504 189.131547,522.346309 C190.260287,513.342589 202.659244,504.134509 226.328419,494.722069 Z"
        fill="currentColor"
      ></path>
    </g>
  </svg>
)

export const InstagramIcon: Icon = ({ className }) => (
  <svg fill="currentColor" strokeWidth="2" viewBox="0 0 24 24" className={className}>
    <path
      fillRule="evenodd"
      d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
      clipRule="evenodd"
    />
  </svg>
)

export const WhatsAppIcon: Icon = ({ className }) => (
  <svg fill="currentColor" viewBox="-15 -15 343 343" className={className}>
    <g>
      <path
        d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156
		c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687
		c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887
		c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153
		c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348
		c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802
		c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922
		c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0
		c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458
		C233.168,179.508,230.845,178.393,227.904,176.981z"
      />
      <path
        d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716
		c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396
		c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z
		 M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188
		l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677
		c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867
		C276.546,215.678,222.799,268.994,156.734,268.994z"
      />
    </g>
  </svg>
)

export const WeChatIcon: Icon = ({ className }) => (
  <svg
    style={{ transform: 'scale(1.1)' }}
    fill="currentColor"
    strokeWidth="48"
    stroke="currentColor"
    className={className}
    viewBox="-48 0 1121 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M498.816 345.056c26.336 0 43.936-17.632 43.936-43.904 0-26.56-17.568-43.744-43.936-43.744s-52.832 17.184-52.832 43.744C446.016 327.424 472.48 345.056 498.816 345.056zM253.088 257.408c-26.336 0-52.96 17.184-52.96 43.744 0 26.272 26.624 43.904 52.96 43.904 26.24 0 43.808-17.632 43.808-43.904C296.864 274.592 279.328 257.408 253.088 257.408zM1024 626.112c0-138.88-128.832-257.216-286.976-269.536 0.224-1.728 0.32-3.52-0.064-5.312-31.712-147.84-190.688-259.296-369.824-259.296C164.704 91.968 0 233.12 0 406.624c0 93.088 47.52 176.96 137.568 243.104l-31.392 94.368c-2.016 6.144-0.192 12.896 4.704 17.152 2.976 2.56 6.72 3.904 10.496 3.904 2.432 0 4.896-0.576 7.168-1.696L246.4 704.48l14.528 2.944c36.288 7.456 67.616 13.92 106.208 13.92 11.36 0 22.88-0.512 34.176-1.472 4.576-0.384 8.448-2.688 11.072-6.016 42.496 106.336 159.616 183.104 297.44 183.104 35.296 0 71.04-8.512 103.104-16.544l90.848 49.664c2.4 1.312 5.056 1.984 7.68 1.984 3.584 0 7.168-1.216 10.048-3.552 5.056-4.096 7.136-10.848 5.248-17.024l-23.2-77.152C981.344 772.864 1024 699.328 1024 626.112zM398.592 687.968c-10.4 0.896-20.96 1.344-31.424 1.344-35.328 0-65.216-6.112-99.776-13.248L247.296 672c-3.456-0.736-7.104-0.256-10.272 1.376l-88.288 44.192 22.944-68.928c2.24-6.752-0.224-14.112-6.016-18.176C76.96 568.64 32 493.312 32 406.624c0-155.84 150.336-282.656 335.136-282.656 163.36 0 308 99.392 337.856 231.584-171.296 2.24-309.888 122.656-309.888 270.56 0 21.504 3.264 42.336 8.768 62.432C402.208 688.128 400.448 687.808 398.592 687.968zM875.456 815.552c-5.344 4.032-7.616 10.976-5.696 17.376l15.136 50.336-62.112-33.984c-2.368-1.312-5.024-1.984-7.68-1.984-1.312 0-2.624 0.16-3.904 0.512-33.312 8.416-67.776 17.088-101.344 17.088-155.904 0-282.72-107.136-282.72-238.816 0-131.68 126.816-238.784 282.72-238.784 152.928 0 282.144 109.344 282.144 238.784C992 691.744 950.624 759.04 875.456 815.552zM612.992 511.968c-17.568 0-35.136 17.696-35.136 35.232 0 17.664 17.568 35.104 35.136 35.104 26.4 0 43.84-17.44 43.84-35.104C656.832 529.632 639.392 511.968 612.992 511.968zM806.016 511.968c-17.312 0-34.88 17.696-34.88 35.232 0 17.664 17.568 35.104 34.88 35.104 26.304 0 44.064-17.44 44.064-35.104C850.08 529.632 832.352 511.968 806.016 511.968z" />
  </svg>
)

export const YouTubeIcon: Icon = ({ className }) => (
  <svg
    xmlSpace="preserve"
    id="Layer_1"
    width="71.412064"
    height="50"
    x="0"
    y="0"
    version="1.1"
    viewBox="0 0 71.412065 50"
    fill="currentColor"
    className={className}
  >
    <g id="g5" transform="scale(.58824)">
      <path
        id="path7"
        d="M118.9 13.3c-1.4-5.2-5.5-9.3-10.7-10.7C98.7 0 60.7 0 60.7 0s-38 0-47.5 2.5C8.1 3.9 3.9 8.1 2.5 13.3 0 22.8 0 42.5 0 42.5s0 19.8 2.5 29.2C3.9 76.9 8 81 13.2 82.4 22.8 85 60.7 85 60.7 85s38 0 47.5-2.5c5.2-1.4 9.3-5.5 10.7-10.7 2.5-9.5 2.5-29.2 2.5-29.2s.1-19.8-2.5-29.3z"
      />
      <path
        id="polygon9"
        className="fill-white group-hover:fill-cyan-600"
        d="M80.2 42.5 48.6 24.3v36.4z"
      />
    </g>
  </svg>
)

export const YandexExpressIcon: Icon = ({ className }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14.1189 14.055C14.071 13.8486 13.4268 13.1466 12.6289 12.5863C11.8784 12.0592 10.1992 11.9107 9.7367 11.7041C9.72507 11.6988 9.72002 11.686 9.72375 11.6739L10.195 10.0781C11.6097 10.1012 12.8517 9.73624 12.6864 8.25804C12.6664 8.13469 12.6458 8.01112 12.6227 7.88975C13.215 7.17961 13.6968 6.31176 13.6184 5.34501C13.5752 4.81175 13.3478 4.31879 13.0699 3.87936C13.0334 3.81967 12.9926 3.75535 12.9496 3.68751C12.6374 3.19632 12.2088 2.52164 12.5707 2.08727C12.8368 1.76855 13.2725 1.73793 13.6535 1.71106H13.6555C13.7075 1.70753 13.7543 1.67405 13.7701 1.62427C13.7982 1.53617 13.7306 1.4485 13.6483 1.43925C13.4685 1.41854 13.1542 1.3778 12.9823 1.32978C12.8943 1.30533 12.8177 1.25268 12.7362 1.19652C12.5659 1.07933 12.3734 0.946955 12.0059 1.02185C11.6991 1.08418 11.4128 1.33374 11.3538 1.83771C11.2774 2.48882 11.5096 2.98993 11.8248 3.55006C12.3723 4.40293 12.8747 5.44391 12.2788 5.99039C11.793 6.43599 11.277 6.10009 11.014 5.89105C11.014 5.89105 11.014 5.89105 11.0138 5.89105C10.4332 5.41946 9.79487 5.13091 9.16117 4.97475C8.8295 4.88245 8.49673 4.83972 8.10887 4.82739C7.39087 4.79941 6.68143 4.96571 6.06704 5.2384C4.10205 4.50778 1.49325 6.38665 1.92172 8.42962C1.95859 8.60496 2.1432 8.70584 2.31046 8.64284L2.52579 8.56156C2.63225 8.52147 2.751 8.54835 2.83353 8.62698C2.83397 8.62742 2.83441 8.62786 2.83485 8.6283C3.33312 9.10342 4.10666 8.82456 4.84199 8.36398L5.50006 8.94945L4.35491 9.70034C4.27106 9.75893 4.18853 9.83602 4.17097 9.93691C3.84106 11.8358 3.30635 12.4911 3.30635 12.4911C2.2277 13.0706 1.96803 14.2671 1.95662 14.642C1.94762 14.9376 2.05342 15.0191 2.19193 14.9964C2.40726 14.9612 3.17311 14.3433 3.80418 13.5563C4.01402 13.2949 4.20346 12.9292 4.38982 12.531C4.70875 11.9371 5.01584 11.3263 5.2878 10.8682C5.39119 10.6942 5.56526 10.577 5.76259 10.5345L8.59463 9.92545L8.6056 9.93492L8.45788 12.2319C8.44119 12.4922 8.62821 12.7363 8.88766 12.751C9.68315 12.7968 10.8941 12.8843 11.6365 13.1369C11.7002 13.4202 12.7836 14.3638 13.7936 14.3055C14.0785 14.2889 14.15 14.1872 14.1193 14.0546L14.1189 14.055Z"
      fill="currentColor"
    ></path>
  </svg>
)

export const ChromiumIcon: Icon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    className={className}
  >
    <path d="M10.88 21.94 15.46 14" />
    <path d="M21.17 8H12" />
    <path d="M3.95 6.06 8.54 14" />
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="4" />
  </svg>
)

export const SingleModeIcon: Icon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="butt"
    strokeLinejoin="miter"
    className={className}
  >
    <circle cx="3" cy="6" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="3" cy="12" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="3" cy="18" r="1.5" fill="currentColor" stroke="none" />
    <path d="M5.8 6H13.6L18.6 10.6" />
    <path d="M5.8 12H18.6" />
    <path d="M5.8 18H13.6L18.6 13.4" />
    <circle cx="21" cy="12" r="1.5" fill="currentColor" stroke="none" />
  </svg>
)

export const BatchModeIcon: Icon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="butt"
    strokeLinejoin="miter"
    className={className}
  >
    <circle cx="3" cy="6" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="3" cy="12" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="3" cy="18" r="1.5" fill="currentColor" stroke="none" />
    <path d="M5.8 6h12.8" />
    <path d="M5.8 12h12.8" />
    <path d="M5.8 18h12.8" />
    <circle cx="21" cy="6" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="21" cy="12" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="21" cy="18" r="1.5" fill="currentColor" stroke="none" />
  </svg>
)

export const MaxIcon: Icon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 720 720" className={className}>
    <path
      fill="currentColor"
      d="M350.4,9.6C141.8,20.5,4.1,184.1,12.8,390.4c3.8,90.3,40.1,168,48.7,253.7,2.2,22.2-4.2,49.6,21.4,59.3,31.5,11.9,79.8-8.1,106.2-26.4,9-6.1,17.6-13.2,24.2-22,27.3,18.1,53.2,35.6,85.7,43.4,143.1,34.3,299.9-44.2,369.6-170.3C799.6,291.2,622.5-4.6,350.4,9.6h0ZM269.4,504c-11.3,8.8-22.2,20.8-34.7,27.7-18.1,9.7-23.7-.4-30.5-16.4-21.4-50.9-24-137.6-11.5-190.9,16.8-72.5,72.9-136.3,150-143.1,78-6.9,150.4,32.7,183.1,104.2,72.4,159.1-112.9,316.2-256.4,218.6h0Z"
    />
  </svg>
)

export const MaxGradientIcon: Icon = ({ className }) => {
  const gradientId = useId()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 720 720"
      className={c`${className}`}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradientId} x1="8%" y1="92%" x2="92%" y2="8%">
          <stop offset="0%" stopColor="#3CC7FF" />
          <stop offset="52%" stopColor="#2E5CF4" />
          <stop offset="100%" stopColor="#A24BFF" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradientId})`}
        d="M350.4,9.6C141.8,20.5,4.1,184.1,12.8,390.4c3.8,90.3,40.1,168,48.7,253.7,2.2,22.2-4.2,49.6,21.4,59.3,31.5,11.9,79.8-8.1,106.2-26.4,9-6.1,17.6-13.2,24.2-22,27.3,18.1,53.2,35.6,85.7,43.4,143.1,34.3,299.9-44.2,369.6-170.3C799.6,291.2,622.5-4.6,350.4,9.6h0ZM269.4,504c-11.3,8.8-22.2,20.8-34.7,27.7-18.1,9.7-23.7-.4-30.5-16.4-21.4-50.9-24-137.6-11.5-190.9,16.8-72.5,72.9-136.3,150-143.1,78-6.9,150.4,32.7,183.1,104.2,72.4,159.1-112.9,316.2-256.4,218.6h0Z"
      />
    </svg>
  )
}
